import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { Colors } from '../../../../theme/Colors';
import { CTATextContent } from '../CTATextContent';
import { getBgColor } from '../utils';
const Styles = labelStyles('CTAStandard', {
    root: (backgroundColor) => css `
    background-color: ${Colors[backgroundColor]};
    padding: 40px 20px;
    @media screen and (min-width: 768px) {
      padding: 60px 30px;
    }

    @media screen and (min-width: 1230px) {
      padding: 80px 20px;
    }
  `,
    content: (maxWidth) => css `
    display: grid;
    align-items: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
    max-width: ${maxWidth}px;
    margin: 0 auto;

    @media screen and (min-width: 768px) {
      gap: 90px;
      grid-template-columns: repeat(2, 1fr);
    }
  `,
    mediaContent: css `
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `,
});
export const CTAStandard = ({ backgroundColor = 'white', heading, subHeading, ctaText, ctaHref, ctaBtnColor, description, onCtaClick, onCtaKeyDown, children, maxWidth = 1170, ctaTarget, }) => {
    const bgColor = getBgColor(backgroundColor);
    return (isolateComponent("div", { css: Styles.root(bgColor) },
        isolateComponent("div", { css: Styles.content(maxWidth) },
            isolateComponent(CTATextContent, { heading: heading, subHeading: subHeading, description: description, ctaText: ctaText, ctaHref: ctaHref, ctaBtnColor: ctaBtnColor, onCtaClick: onCtaClick, onCtaKeyDown: onCtaKeyDown, bgColor: bgColor, ctaTarget: ctaTarget }),
            isolateComponent("div", { css: Styles.mediaContent, "data-testid": "media-content" }, children))));
};
//# sourceMappingURL=CTAStandard.js.map
// @zapier/design-system@6.14.1 (10126c41d)
